import { Component, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { AppDiscoveryService } from 'src/app/services/app-discovery.service';

@Component({
    selector: 'ins-app-landing',
    templateUrl: './app-landing.component.html',
    styleUrls: ['./app-landing.component.scss'],
    imports: [MatIcon]
})
export class AppLandingComponent implements OnInit {
  public context: string = '';
  constructor(private readonly route: ActivatedRoute, private readonly appDiscoveryService: AppDiscoveryService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.context = this.route.snapshot.queryParams['previousRoute'] || '';

    // Check if query string contains intosite-site-viewpoint key
    const queryParams = this.route.snapshot.queryParams;
    if (queryParams['intosite-site-viewpoint'] || queryParams['intosite-object-viewpoint']) {
      this.context = 'wait';
      const queryString = Object.keys(queryParams)
        .map(key => `${key}=${queryParams[key]}`)
        .join('&');

      setTimeout(() => {
        if (this.appDiscoveryService.hasOtherMainTabOpen()) {
          this.context = 'copyLinkRedirect';
          localStorage.setItem('proxyPath', queryString);
        } else {
          const updatedParams = { 'intosite-proxy': 'yes', ...queryParams};
          delete updatedParams['company'];
          this.router.navigate(['/'], { queryParams: updatedParams });
        }
      }, 1000);

    }
  }
}
